export default "__VITE_ASSET__BN2Iof2j__"